rjm.ui.ChartBuilderButtonsView = Backbone.View.extend(
  events:
    "click #save": "save"
    "click #showSaveAs": "showSaveAs"
    "click #cancel": "cancel"
    "click #saveWarningCancel": "warningCancel"
    "click #saveWarningSave": "warningContinue"
    "click #saveAsSave": "saveAs"
    "click #saveAsCancel": "hideSaveAs"

  initialize: (options) ->
    if not options or not options.chartModel or not options.viewState
      throw "InvalidConstructorArgs - ChartBuilderButtonsView"

    _.bindAll this, "save", "reloadDashboardItems", "saveAs", "checkInvalidCharacters", "showSaveAs", "hideSaveAs", "cancel", "warningCancel", "warningContinue", "generateTemplateData", "unblock", "block", "render"
    #set incoming options
    @model = options.chartModel
    @viewState = options.viewState

    #initialize local variables
    @disableSave = false
    @saveAction = null

    #keep track of model changes
    @initialTimeInterval = @model.get('timeInterval')
    @initialTimeFrame = JSON.stringify(@model.get('timeFrame').toJSON())
    @initialScalar = @model.isScalar()

    #bind model events
    @listenTo @viewState, "change:renderButtons", @render
    @listenTo @model, "change:api_conn_id", @block
    @listenTo @model.getCurrentSeries(), "change:trend", @unblock
    return

  save: (e) ->
    e.preventDefault()

    if @disableSave
      return false

    @saveAction = 'save'
    if not @viewState.get('filtersApplied')
      $(@el).find('#saveWarning').modal('show')
      return false

    #Make sure we set a default name if not specified
    @model.set name: "Untitled Chart"  unless @model.get("name")?

    #check if the chart is new
    isNewChart = true  unless @model.id?

    @viewState.set isSaving: true

    chartNameValidity = @checkInvalidCharacters(@model.get('name'))
    if chartNameValidity.invalid
      @viewState.set
        chartValidationErrors: 
          name: chartNameValidity.error
        isSaving: false
      return

    #we want to first save the chart
    $.blockUI message: "Saving..."

    $.when(@model.save())
    .fail (saveResponse) =>
      @viewState.set 
        chartValidationErrors: JSON.parse(saveResponse.responseText).error
        isSaving: false
      @render()
      $.unblockUI()
    .done (saveResponse) =>
      @viewState.set chartValidationErrors: {} # we shouldn't be allowed to save if there are any client-side validation errors
      @reloadDashboardItems(isNewChart, 0)

    return

  reloadDashboardItems: (isNewChart, includePeers) ->
    $.when($.get($.url("/chartBuilder/" + @model.get('clientId') + "/chartIdProperties?chid=" + @model.id + "&dashId=" + @model.get("dashboardId") + "&includePeers=" + includePeers)))
    .then($.unblockUI())
    .done (chartIdProps) =>
      #this is a new chart so we need to add a new box for it
      if isNewChart
        parent.closeChartBuilder()
        parent.createAChartBox chartIdProps.chartDashboardItemIds[0], 1, chartIdProps.chsid, null, parent.defaultTimeout, true, chartIdProps.chid
      #reload all affected dashboard items
      else
        _(chartIdProps.chartDashboardItemIds).each (dcid) =>
          parent.reloadDCID dcid, @model.id, chartIdProps.chsid
        _(chartIdProps.dependentDashboardItemIds).each (dcid) =>
          parent.reloadDCID dcid, @model.id

      #hide the chart builder box
      parent.closeChartBuilder()

  saveAs: (e) ->
    e.preventDefault()

    # We may be saveAsing someone else's chart, so set this chart to the current user
    @model.attributes.userId = window.getCurrentUserId()

    newName = $("#chartName").val()
    if newName.length is 0
      $(@el).find(".error.invalid").text("Please enter a new name for this chart")
      return
    else
      chartNameValidity = @checkInvalidCharacters(newName)
      if chartNameValidity.invalid
        $(@el).find(".error.invalid").text(chartNameValidity.error)
        return
    oldName = @model.get("name")
    oldId = @model.id

    @model.set
        id: 0
        name: newName
        figureId: null
    @hideSaveAs()
    $.blockUI message: "Saving..."
    @viewState.set isSaving: true

    $.when(@model.save())
    .fail (saveResponse) =>
      @model.set
          name: oldName  
          id: oldId
      @viewState.set isSaving: false
      $(@el).find(".error.invalid").text(JSON.parse(saveResponse.responseText).error.name)      
      $.unblockUI()
      $(@el).find('#saveAs').modal('show')
    .done (saveResponse) =>
      @model.set isCompositeInput: false
      @model.set figureId: saveResponse.figureId

      $.when($.get($.url("/chartBuilder/" + @model.get('clientId') + "/chartIdProperties?chid=" + @model.id)))
      .then =>
        $.unblockUI()
        @viewState.set isSaving: false
      .done (chartIdProps) ->
        parent.createAChartBox chartIdProps.chartDashboardItemIds[0], 1, chartIdProps.chsid, null, parent.defaultTimeout, true

  checkInvalidCharacters: (name) ->
    # < > are not allowed because we strip them on the server side in order to prevent cross-site scripting
    # ; are not allowed because they break the composite chart editor
    if name.indexOf('<') isnt -1 or name.indexOf('>') isnt -1 or name.indexOf(';') isnt -1
      return {
        invalid: true
        error: "Chart names are not allowed to include '<','>' or ';'"
      }

    return {
      invalid: false
      error: ""
    }

  showSaveAs: (e) ->
    e?.preventDefault()
    # There is no SaveAs if we're creating a new chart
    if @disableSave or @viewState.get("isCreate")
      return false

    @saveAction = 'saveAs'
    if not @viewState.get('filtersApplied')
      $(@el).find('#saveWarning').modal('show')
      return false

    $(@el).find(".error.invalid").text("")
    $(@el).find("#chartName").val("Copy of "+@model.get("name"))
    $(@el).find("#saveWarningHeader").text("Save '"+@model.get("name")+"' as")
    $(@el).find('#saveAs').modal('show')

  hideSaveAs: (e) ->
    e?.preventDefault()
    $(@el).find('#saveAs').modal('hide')

  cancel: (e) ->
    e.preventDefault()
    @viewState.set 
        chartValidationErrors: {}
    parent.closeChartBuilder()

  warningCancel: (e) ->
    e.preventDefault()
    @saveAction = false
    $(@el).find('#saveWarning').modal('hide')

  warningContinue: (e) ->
    @model.trigger "clearFilters"
    $(@el).find('#saveWarning').modal('hide')
    if @saveAction is 'save'
      @save(e)
    if @saveAction is 'saveAs'
      @showSaveAs(e)

  generateTemplateData: ->
    disableSave: @disableSave
    disableSaveAs: @disableSaveAs or @disableSave
    name: @model.get("name")
    showCancel: @model.get("dashboardId") isnt 0

  unblock: ->
    @$('#cbSaveButtons').removeClass "blocked"

  block: ->
    @$('#cbSaveButtons').addClass "blocked"

  render: ->
    @disableSave = _(@viewState.get("chartValidationErrors").restrictionSequence).isString() # completely disable save function if there is an invalid restriction sequence
    if @viewState.get("isCreate")
      $(@el).find("#saveAs").addClass('disabled').removeClass("btn-info")
      $(@el).find("#saveAs").attr "disabled", "disabled"
      @disableSaveAs = true
    @viewState.set {renderButtons: false}, {silent: true}
    if @model.isCohortChart()
      @$('#standardMode').removeClass 'active'
      @$('#cohortMode').addClass 'active'
    else
      @$('#standardMode').addClass 'active'
      @$('#cohortMode').removeClass 'active'
    $(@el).html ich.chartBuilderButtons(@generateTemplateData())

    @$("#showSaveAs").tooltip
      html: true
      placement: "bottom"
      trigger: "manual"
      container: "body"
      title: "<div style='width: 175px;'>Create a copy of this chart on the dashboard.</div>"

    return @
)
